type ApiAction = import('types/api').ApiPayloadAction
type ApiRequestConfig = import('types/api').ApiRequestConfig

export const create = (action: ApiAction): ApiRequestConfig => {
  return {
    url: '/bookmarks',
    method: 'POST',
    data: {
      id: action.payload.id,
      content: action.payload.content,
      nodeIds: action.payload.nodeIds
    }
  }
}

export const edit = (action: ApiAction): ApiRequestConfig => {
  return {
    url: `/bookmarks/${action.payload.id}`,
    method: 'PUT',
    data: {
      content: action.payload.content,
      nodeIds: action.payload.nodeIds
    }
  }
}

const deleteBookmark = (action: ApiAction): ApiRequestConfig => {
  return {
    url: `/bookmarks/${action.payload.id}`,
    method: 'DELETE'
  }
}

export { deleteBookmark as delete }

export const getAll = (_action: ApiAction): ApiRequestConfig => {
  return {
    url: '/bookmarks'
  }
}
